import * as types from './types';

// Action creators
export const storeResults = (results) => {
  return (dispatch) => {
    dispatch({
      type: types.STORE_RESULTS,
      results,
    });
  };
};

export const storeReg = (reg) => {
  return (dispatch) => {
    dispatch({
      type: types.STORE_REG,
      reg,
    });
  };
};

export const storeEnvUrl = (url) => {
  return (dispatch) => {
    dispatch({
      type: types.STORE_ENV_URL,
      url,
    });
  };
};

export const storeEnvToken = (token) => {
  return (dispatch) => {
    dispatch({
      type: types.STORE_ENV_TOKEN,
      token,
    });
  };
};

export const storeSelected = (selected) => {
  return (dispatch) => {
    dispatch({
      type: types.STORE_SELECTED,
      selected,
    });
  };
};

export default { storeResults, storeReg, storeEnvUrl, storeEnvToken, storeSelected };
